import ImageBanner from "./ImageBanner";
import {ImageBannerName} from "./intefaces";

export default ImageBanner;
export {ImageBannerName};
